<div class="wrapper-progress" [style.width]="(width || 100) + '%'">
  <span class="legend-top-progress">{{mainLegend}}</span>
  <div class="progress">
    @for (item of data; track $index) {
      <div class="progress-bar" role="progressbar"
        [style.width]="((item.value - min)/(max - min) * 100) + '%'"
        [ngClass]="{ 'bg-warning': item.style == progressBarStyle.Warn, 'bg-warning2': item.style == progressBarStyle.Warn2,'bg-warning3': item.style == progressBarStyle.Warn3, 'bg-warning4': item.style == progressBarStyle.Warn4, 'bg-alert': item.style == progressBarStyle.Alert, 'bg-alert2': item.style == progressBarStyle.Alert2, 'bg-alert3': item.style == progressBarStyle.Alert3, 'bg-alert4': item.style == progressBarStyle.Alert4 }"
        attr.aria-valuenow="{{item.value}}" attr.aria-valuemin="{{min}}" attr.aria-valuemax="{{max}}">
        {{item.text}}
      </div>
    }
  </div>
  <div class="legend-bottom-progress">
    @for (item of data; track $index) {
      <span [style.width]="((item.value - min)/(max - min) * 100) + '%'">
        {{item.legend}}
      </span>
    }
  </div>
</div>
